/* eslint-disable */

import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import client from '../../api/client';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import { colors } from '../../helper/constant';
import './MarketPlace.css';
import './ProductView.css';

import { Image } from 'antd';
import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import placeholderImg from '../../assets/images/placeholder.webp';

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MarketPlace(props) {
  const queryClient = useQueryClient();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const shopId = props.permitdata?.shop_id;
  const shopitemId = searchParams.get('shopitem');
  const productitemId = searchParams.get('productitem');

  const [tableitem, setTableitem] = useState([]);
  const [tablestock, setTablestock] = useState([]);
  const [PreviewImage1, setPreviewImage1] = useState(`${process.env.PUBLIC_URL}/images/medicine/blank.png`);
  const [PreviewImage2, setPreviewImage2] = useState(`${process.env.PUBLIC_URL}/images/medicine/blank.png`);
  const [PreviewImage3, setPreviewImage3] = useState(`${process.env.PUBLIC_URL}/images/medicine/blank.png`);
  const [PreviewIndex, setPreviewIndex] = useState(1);
  const [slidefade, setSlidefade] = useState('fadeInRight');
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });
  const [cartStock, setCartStock] = useState({}); // Stores total qty in cart per expire date
  const [selectedBatchIndex, setSelectedBatchIndex] = useState(0);
  const [detailTab, setDetailTab] = useState('desc');

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const productViewQuery = useQuery({
    queryKey: ['product-view', shopId, shopitemId, productitemId],
    queryFn: async () => {
      await sleep(500);

      const formData = new FormData();
      formData.append('shop_id', shopId);
      formData.append('shopitem_id', shopitemId);
      formData.append('productitem_id', productitemId);
      if (shopId) {
        formData.append('buyer_shopid', shopId);
      }

      const response = await client.post('/api/market/productview', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'productview failed');
      }
      return {
        product: response.data.items[0],
        compare: response.data.items_com ?? [],
      };
    },
    enabled: !!(shopitemId && productitemId),
  });

  const productview = productViewQuery.data?.product ?? {};
  const product_compare = productViewQuery.data?.compare ?? [];

  const addToCartMutation = useMutation({
    mutationFn: async ({ formData }) => {
      const response = await client.post('/api/order/mycart/add', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'add to cart failed');
      }
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['cart', shopId] });
      props.callback_mycart('add');

      setCartStock((prev) => {
        const newCartStock = { ...prev };
        variables.temp.forEach((itemStr) => {
          const parts = itemStr.split('**');
          if (parts.length >= 3) {
            const unit = Number(parts[0]) || 0;
            const expire = parts[1];
            const qty = Number(parts[2]) || 0;
            if (!newCartStock[expire]) newCartStock[expire] = 0;
            newCartStock[expire] += unit * qty;
          }
        });
        return newCartStock;
      });

      setTableitem((prev) => prev.map((item) => ({ ...item, select: 0 })));

      const token = Math.random().toString(36).substring(2, 22);
      navigate('/marketplace/mycart?cart=' + token);
    },
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  function showStockWarning(message) {
    setModal_popup({
      modaltype: 'modal-warning',
      headers: 'ขออภัย',
      message,
      enable: true,
    });
  }

  useEffect(() => {
    if (addToCartMutation.isPending) {
      setmodal_load({ enable: true, message: 'กำลังเพิ่มสินค้าลงในตะกร้า' });
    } else if (productViewQuery.isFetching && !productViewQuery.data) {
      setmodal_load({ enable: true, message: 'กำลังโหลดรายละเอียดสินค้า' });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [productViewQuery.isFetching, productViewQuery.data, addToCartMutation.isPending]);

  useEffect(() => {
    if (!productViewQuery.isError) return;
    setModal_popup({
      modaltype: 'modal-error',
      headers: 'ผิดพลาด',
      message: productViewQuery.error?.message ?? 'ผิดพลาด',
      enable: true,
    });
  }, [productViewQuery.isError, productViewQuery.error]);

  useEffect(() => {
    if (!addToCartMutation.isError) return;
    setmodal_load({ enable: false, message: '' });
    setModal_popup({
      modaltype: 'modal-error',
      headers: 'ผิดพลาด',
      message: addToCartMutation.error?.message ?? 'ผิดพลาด',
      enable: true,
    });
  }, [addToCartMutation.isError, addToCartMutation.error]);

  useEffect(() => {
    if (productview && productview.pricetable) {
      if (productview.productitem_id && productview.img1_key) {
        setPreviewImage1(
          `${process.env.REACT_APP_IMAGE_URL}${productview.productitem_id}/${productview.productitem_id}-1-${productview.img1_key}.jpg`,
        );
      }
      if (productview.productitem_id && productview.img2_key) {
        setPreviewImage2(
          `${process.env.REACT_APP_IMAGE_URL}${productview.productitem_id}/${productview.productitem_id}-2-${productview.img2_key}.jpg`,
        );
      }
      if (productview.productitem_id && productview.img3_key) {
        setPreviewImage3(
          `${process.env.REACT_APP_IMAGE_URL}${productview.productitem_id}/${productview.productitem_id}-3-${productview.img3_key}.jpg`,
        );
      }

      const stockdata = [];
      const stockRows = productview.on_stock ? productview.on_stock.split('##') : [];
      stockRows.forEach((rowitem) => {
        const stockitems = rowitem.split('**');
        if (stockitems.length >= 2) {
          stockdata.push({ expire: stockitems[0], stock: Number(stockitems[1]) || 0 });
        }
      });
      setTablestock(stockdata);

      const stockByExpire = Object.fromEntries(stockdata.map((s) => [s.expire, s.stock]));

      // Parse cart_select_item
      const cartStockData = {};
      if (productview.cart_select_item) {
        const cartRows = productview.cart_select_item.split('##');
        cartRows.forEach((row) => {
          const parts = row.split('**');
          if (parts.length >= 3) {
            const unit = Number(parts[0]) || 0;
            const expire = parts[1];
            const qty = Number(parts[2]) || 0;
            // key is uniuqe per unit+expire but we aggregate by expire for stock check
            // Actually stock check is per expire date. Product table has multiple units but they share the same expire stock pool?
            // Looking at `stepup`: previous_sum += item.select * item.unit.
            // Yes, `fnd.stock` where `element.expire === exp`.
            // So `fnd.stock` is the total stock for that expire date.
            // We need to sum up (unit * qty) for each expire date from the cart.
            if (!cartStockData[expire]) cartStockData[expire] = 0;
            cartStockData[expire] += unit * qty;
          }
        });
      }
      setCartStock(cartStockData);

      const pricedata = [];
      const rows = productview.pricetable ? productview.pricetable.split('##') : [];
      if (rows.length > 0) {
        rows.forEach((rowitem, index) => {
          const items = rowitem.split('**');
          if (items.length >= 4) {
            const unit = Number(items[0]) || items[0];
            const price = Number(items[1]) || 0;
            const pricepromotion = Number(items[2]) || 0;
            const expire = items[3];
            if (price > 0) {
              pricedata.push({
                pricelist_id: productview.shopitem_id + '-' + index.toString(),
                unit,
                price,
                pricepromotion,
                expire,
                stock: stockByExpire[expire] || 0,
                select: 0,
              });
            }
          }
        });
      }
      setTableitem(pricedata);
    }
  }, [productview]);

  const displayPrice = useMemo(() => {
    if (!tableitem || tableitem.length === 0) return null;
    const promoPrices = tableitem
      .filter((i) => Number(i.pricepromotion) > 0)
      .map((i) => Number(i.pricepromotion));
    const normalPrices = tableitem.map((i) => Number(i.price));
    const minPromo = promoPrices.length > 0 ? Math.min(...promoPrices) : null;
    const minNormal = normalPrices.length > 0 ? Math.min(...normalPrices) : null;
    if (minPromo !== null) {
      return { price: minPromo, old: minNormal };
    }
    return { price: minNormal, old: null };
  }, [tableitem]);

  const totalStock = useMemo(() => {
    if (!tablestock || tablestock.length === 0) return 0;
    return tablestock.reduce((sum, s) => sum + (Number(s.stock) || 0), 0);
  }, [tablestock]);

  function preview_back() {
    setSlidefade('fadeInLeft');
    setPreviewIndex((prev) => (prev === 1 ? 3 : prev - 1));
  }

  function preview_next() {
    setSlidefade('fadeInRight');
    setPreviewIndex((prev) => (prev === 3 ? 1 : prev + 1));
  }

  function preview_fix(index) {
    setSlidefade('fadeInRight');
    setPreviewIndex(index);
  }

  function fmtExpire(dateStr) {
    const d = dayjs(dateStr);
    return d && d.isValid() ? d.format('DD MMM BBBB') : '-';
  }

  function handleBack() {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/marketplace?category=รวมสินค้า');
    }
  }

  function selectunit(id, exp, unit, value) {
    if (value > 0) {
      var fnd = tablestock.find((element) => {
        return element.expire === exp;
      });
      if (fnd !== undefined) {
        var new_sum = Number(value) * Number(unit);

        // Check against stock AND cart quantity
        const cartQty = cartStock[exp] || 0;
        if (new_sum + cartQty <= Number(fnd.stock)) {
          const nexttableitem = tableitem.map((item) => {
            if (item.pricelist_id !== id) {
              return item;
            } else {
              return {
                ...item,
                select: value,
              };
            }
          });
          setTableitem(nexttableitem);
        } else {
          // Exceeds stock (considering cart)
          showStockWarning(
            `สินค้าคงเหลือไม่เพียงพอ (ในตะกร้า: ${cartQty}, คงเหลือ: ${Number(fnd.stock)})`,
          );

          const nexttableitem = tableitem.map((item) => {
            return item;
          });
          setTableitem(nexttableitem);
        }
      } else {
        const nexttableitem = tableitem.map((item) => {
          if (item.pricelist_id !== id) {
            return item;
          } else {
            return {
              ...item,
              select: 0,
            };
          }
        });
        setTableitem(nexttableitem);
      }
    } else {
      const nexttableitem = tableitem.map((item) => {
        if (item.pricelist_id !== id) {
          return item;
        } else {
          return {
            ...item,
            select: 0,
          };
        }
      });
      setTableitem(nexttableitem);
    }
  }

  function stepup(id, exp, unit) {
    var fnd = tablestock.find((element) => {
      return element.expire === exp;
    });
    if (fnd !== undefined) {
      // const cartQty = cartStock[exp] || 0;

      var previous_sum = 0;
      const nextsum = tableitem.map((item) => {
        // Only sum items with SAME expire date!
        if (item.expire === exp) {
          previous_sum += Number(item.select) * Number(item.unit);
        }
        return item;
      });

      var new_sum = previous_sum + Number(unit);

      // Check against stock AND cart quantity
      const cartQty = cartStock[exp] || 0;

      if (new_sum + cartQty <= Number(fnd.stock)) {
        const nexttableitem = tableitem.map((item) => {
          if (item.pricelist_id !== id) {
            return item;
          } else {
            return {
              ...item,
              select: Number(item.select) + 1,
            };
          }
        });
        setTableitem(nexttableitem);
      } else {
        showStockWarning(
          `สินค้าคงเหลือไม่เพียงพอ (ในตะกร้า: ${cartQty}, คงเหลือ: ${Number(fnd.stock)})`,
        );
        const nexttableitem = tableitem.map((item) => {
          return item;
        });
        setTableitem(nexttableitem);
      }
    } else {
      const nexttableitem = tableitem.map((item) => {
        if (item.pricelist_id !== id) {
          return item;
        } else {
          return {
            ...item,
            select: 0,
          };
        }
      });
      setTableitem(nexttableitem);
    }
  }

  function stepdown(id, exp) {
    const nexttableitem = tableitem.map((item) => {
      if (item.pricelist_id !== id) {
        return item;
      } else {
        if (Number(item.select) > 0) {
          return {
            ...item,
            select: Number(item.select) - 1,
          };
        } else {
          return item;
        }
      }
    });
    setTableitem(nexttableitem);
  }

  async function api_addcard() {
    if (props.permitdata.role !== 'guest' && props.permitdata.token !== '') {
      if (props.permitdata.shop_id !== productview.shop_id) {
        var temp = [];
        const formData = new FormData();
        tableitem.forEach((item, index) => {
          if (Number(item.select) > 0) {
            var x = item.unit + '**' + item.expire + '**' + item.select;
            temp.push(x);
          }
        });

        if (temp.length > 0) {
          var pricestring = temp.join('##');
          formData.append('buyer_shopid', props.permitdata.shop_id);
          formData.append('seller_shopid', productview.shop_id);
          formData.append('shopitem_id', productview.shopitem_id);
          formData.append('select_item', pricestring);
          formData.append('select_common', 'True');

          addToCartMutation.mutate({ formData, temp });
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: 'กรุณากรอกจำนวนสินค้า',
            enable: true,
          });
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: 'ระบบไม่อนุญาตให้ซื้อสินค้าภายในร้านตัวเอง',
          enable: true,
        });
      }
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'กรุณาเข้าสู่ระบบก่อนทำการสั่งซื้อหรือเพิ่มสินค้าลงในตะกร้า',
        enable: true,
      });
    }
  }

  async function api_buynow() {
    if (props.permitdata.role !== 'guest' && props.permitdata.token !== '') {
      if (props.permitdata.shop_id !== productview.shop_id) {
        var temp = [];
        var overstock = false;
        tableitem.forEach((item, index1) => {
          if (Number(item.select) > 0) {
            var x = item.unit + '**' + item.expire + '**' + item.select;
            temp.push(x);
          }

          if (Number(item.select) > Number(item.stock)) {
            overstock = true;
          }
        });

        if (overstock === false) {
          if (temp.length > 0) {
            navigate(
              '/marketplace/mypayment?source=product&shopitem=' +
              productview.shopitem_id +
              '&item=' +
              temp.join('--'),
            );
          } else {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: 'กรุณาเลือกสินค้าเพื่อทำการชำระเงิน',
              enable: true,
            });
          }
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: 'ท่านกรอกข้อมูลสินค้าเกินกว่าจำนวนสินค้าคงเหลือ',
            enable: true,
          });
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: 'ระบบไม่อนุญาตให้ซื้อสินค้าภายในร้านตัวเอง',
          enable: true,
        });
      }
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'กรุณาเข้าสู่ระบบก่อนทำการสั่งซื้อหรือเพิ่มสินค้าลงในตะกร้า',
        enable: true,
      });
    }
  }

  return (
    <main className='pv-main-container font-th'>
      <div className='container'>
        {/* Breadcrumb Navigation */}
        <div className='mb-3 d-none d-md-block'>
          <nav aria-label='breadcrumb'>
            <ol className='breadcrumb bg-transparent p-0 mb-0 border-0 shadow-none'>
              <li className='breadcrumb-item font-th border-0 bg-transparent'>
                <Link to='/marketplace?category=รวมสินค้า' style={{ color: '#334155', fontWeight: '500', backgroundColor: 'transparent' }}>
                  หน้าแรก
                </Link>
              </li>
              {productview && productview.shop_name && (
                <li className='breadcrumb-item font-th border-0 bg-transparent'>
                  <Link
                    to={`/marketplace/shopseller?shopcode=${productview.shop_id}&category=รวมสินค้า`}
                    style={{ color: '#334155', fontWeight: '500', backgroundColor: 'transparent' }}
                  >
                    {productview.shop_name}
                  </Link>
                </li>
              )}
              <li className='breadcrumb-item font-th active border-0 bg-transparent'>
                <span style={{ color: '#2196f3', fontWeight: '700', backgroundColor: 'transparent' }}>
                  {productview.productitem_name || 'รายละเอียดสินค้า'}
                </span>
              </li>
            </ol>
          </nav>
        </div>

        <div className='pv-content-card'>
        <div className='pv-top-nav'>
              <button type='button' className='pv-back-btn' onClick={handleBack}>
                <i className='fe-arrow-left'></i>
                <span>ย้อนกลับ</span>
              </button>
            </div>
          <div className='row'>
            {/* Gallery Section */}
            <div className='col-md-5'>
              <div className='pv-gallery-container'>
                <div className='pv-main-image'>
                  <Image
                    src={
                      PreviewIndex === 1
                        ? PreviewImage1
                        : PreviewIndex === 2
                          ? PreviewImage2
                          : PreviewImage3
                    }
                    fallback={placeholderImg}
                  />
                  {productview.isblank && <div className='pv-out-of-stock'>สินค้าหมด</div>}
                </div>
                <div className='pv-thumb-strip'>
                  {[1, 2, 3].map((idx) => (
                    <div
                      key={idx}
                      className={`pv-thumb-item ${PreviewIndex === idx ? 'active' : ''}`}
                      onClick={() => preview_fix(idx)}
                    >
                      <img
                        src={idx === 1 ? PreviewImage1 : idx === 2 ? PreviewImage2 : PreviewImage3}
                        alt={`thumb-${idx}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Info Section */}
            <div className='col-md-7'>
              <h1 className='pv-title'>{productview.productitem_name}</h1>
              <p className='pv-subtitle'>{productview.productitem_inter}</p>

              <div className='pv-price-box'>
                <div className='d-flex align-items-baseline'>
                  <span className='pv-price-main'>
                    {displayPrice && displayPrice.price
                      ? Number(displayPrice.price).toLocaleString()
                      : '-'}{' '}
                    บาท
                  </span>
                  {displayPrice && displayPrice.old && (
                    <>
                      <span className='pv-price-old'>
                        {Number(displayPrice.old).toLocaleString()} บาท
                      </span>
                      <span className='pv-discount-badge'>
                        ลด{' '}
                        {Math.round(
                          ((displayPrice.old - displayPrice.price) / displayPrice.old) * 100,
                        )}
                        %
                      </span>
                    </>
                  )}
                </div>
                <div className='mt-2 text-muted small'>
                  <i className='fe-package mr-1'></i> คงเหลือทั้งหมด{' '}
                  <strong>{totalStock.toLocaleString()}</strong> ชิ้น
                </div>
              </div>

              <div className='pv-shop-bar'>
                <i className='fe-shopping-bag text-primary font-size-20'></i>
                <div className='flex-grow-1'>
                  <Link
                    to={`/marketplace/shopseller?shopcode=${productview.shop_id}&category=รวมสินค้า`}
                    className='pv-shop-name'
                  >
                    {productview.shop_name}
                  </Link>
                  <div className='text-muted small'>ตรวจสอบร้านค้าเพื่อดูสินค้าเพิ่มเติม</div>
                </div>
                <Link
                  to={`/marketplace/shopseller?shopcode=${productview.shop_id}&category=รวมสินค้า`}
                  className='btn btn-outline-primary btn-sm rounded-pill px-3'
                >
                  ไปที่ร้านค้า
                </Link>
              </div>

              <>
                {/* Variations Section */}
                <div className='mb-4'>
                  <h6 className='font-weight-bold mb-3'>เลือกขนาด/หน่วย</h6>
                  <div className='pv-variation-grid'>
                    {tableitem.map((item, index) => (
                      <div
                        key={item.pricelist_id}
                        className={`pv-variation-card ${selectedBatchIndex === index ? 'active' : ''} ${item.stock <= 0 ? 'sold-out' : ''}`}
                        onClick={() => item.stock > 0 && setSelectedBatchIndex(index)}
                      >
                        <div className='pv-var-unit'>
                          {item.unit} ชิ้น {item.pricepromotion > 0 && <i className='fe-zap text-warning ml-1'></i>}
                        </div>
                        <div className='pv-var-price'>
                          {item.pricepromotion > 0
                            ? Number(item.pricepromotion).toLocaleString()
                            : Number(item.price).toLocaleString()}{' '}
                          ฿
                        </div>
                        <div className='pv-var-expire'>
                          <i className='fe-calendar mr-1'></i> Exp. {fmtExpire(item.expire)}
                        </div>
                        <div className='pv-var-stock'>คงเหลือ {item.stock}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Quantity Section */}
                {tableitem.length > 0 && tableitem[selectedBatchIndex] && (
                  <div className='pv-quantity-section'>
                    <div className='flex-grow-1'>
                      <div className='font-weight-bold'>จำนวนที่ต้องการ</div>
                      <div className='text-muted small'>
                        {tableitem[selectedBatchIndex].unit} ชิ้น / {fmtExpire(tableitem[selectedBatchIndex].expire)}
                      </div>
                    </div>
                    <div className='pv-quantity-selector'>
                      <button
                        className='pv-qty-btn'
                        onClick={() =>
                          stepdown(
                            tableitem[selectedBatchIndex].pricelist_id,
                            tableitem[selectedBatchIndex].expire,
                          )
                        }
                      >
                        <i className='fe-minus'></i>
                      </button>
                      <input
                        type='number'
                        className='pv-qty-input'
                        value={tableitem[selectedBatchIndex].select}
                        onChange={(e) => {
                          const v = Math.max(0, parseInt(e.target.value || '0', 10));
                          selectunit(
                            tableitem[selectedBatchIndex].pricelist_id,
                            tableitem[selectedBatchIndex].expire,
                            tableitem[selectedBatchIndex].unit,
                            v,
                          );
                        }}
                      />
                      <button
                        className='pv-qty-btn'
                        onClick={() =>
                          stepup(
                            tableitem[selectedBatchIndex].pricelist_id,
                            tableitem[selectedBatchIndex].expire,
                            tableitem[selectedBatchIndex].unit,
                          )
                        }
                      >
                        <i className='fe-plus'></i>
                      </button>
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                <div className='pv-action-group'>
                  <button
                    className='pv-btn pv-btn-cart'
                    onClick={() => api_addcard()}
                    disabled={modal_load.enable || tableitem.every((i) => Number(i.select) === 0)}
                  >
                    <i className='fe-shopping-cart'></i> เพิ่มลงตะกร้า
                  </button>
                  <button
                    className='pv-btn pv-btn-buy'
                    onClick={() => api_buynow()}
                    disabled={modal_load.enable || tableitem.every((i) => Number(i.select) === 0)}
                  >
                    ซื้อเลยตอนนี้
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>

        {/* Detailed Sections */}
        <div className='pv-detail-tabs'>
          <div className='pv-tab-header' role='tablist' aria-label='รายละเอียดสินค้า'>
            <button
              type='button'
              role='tab'
              aria-selected={detailTab === 'desc'}
              className={`pv-tab-item ${detailTab === 'desc' ? 'active' : ''}`}
              onClick={() => setDetailTab('desc')}
            >
              รายละเอียดสินค้า
            </button>
            <button
              type='button'
              role='tab'
              aria-selected={detailTab === 'info'}
              className={`pv-tab-item ${detailTab === 'info' ? 'active' : ''}`}
              onClick={() => setDetailTab('info')}
            >
              ข้อมูลสินค้า
            </button>
            <button
              type='button'
              role='tab'
              aria-selected={detailTab === 'compare'}
              className={`pv-tab-item ${detailTab === 'compare' ? 'active' : ''}`}
              onClick={() => setDetailTab('compare')}
            >
              เปรียบเทียบราคา
              {product_compare.length > 0 && (
                <span className='pv-tab-badge'>{product_compare.length}</span>
              )}
            </button>
          </div>

          <div className='pv-content-card pv-tab-panel'>
            {detailTab === 'desc' && (
              <div className='pv-description' role='tabpanel'>
                {productview.productitem_desc ? (
                  productview.productitem_desc.split('\n').map((line, idx) => (
                    <p key={idx} className='mb-2'>{line}</p>
                  ))
                ) : (
                  <div className='pv-tab-empty'>
                    <i className='fe-file-text'></i>
                    <p>ไม่มีรายละเอียดสินค้า</p>
                  </div>
                )}
              </div>
            )}

            {detailTab === 'info' && (
              <div className='pv-info-panel' role='tabpanel'>
                <div className='pv-info-grid'>
                  <div className='pv-info-row'>
                    <span className='pv-info-label'>รหัสสินค้า</span>
                    <span className='pv-info-value'>{productview.productitem_id || '-'}</span>
                  </div>
                  <div className='pv-info-row'>
                    <span className='pv-info-label'>ชื่อสากล</span>
                    <span className='pv-info-value'>{productview.productitem_inter || '-'}</span>
                  </div>
                  {productview.productitem_barcode && (
                    <div className='pv-info-row'>
                      <span className='pv-info-label'>บาร์โค้ด</span>
                      <span className='pv-info-value'>{productview.productitem_barcode}</span>
                    </div>
                  )}
                  <div className='pv-info-row'>
                    <span className='pv-info-label'>ร้านค้า</span>
                    <span className='pv-info-value'>{productview.shop_name || '-'}</span>
                  </div>
                  <div className='pv-info-row'>
                    <span className='pv-info-label'>คงเหลือทั้งหมด</span>
                    <span className='pv-info-value'>{totalStock.toLocaleString()} ชิ้น</span>
                  </div>
                </div>

                {tableitem.length > 0 && (
                  <div className='pv-info-table-wrap'>
                    <h6 className='pv-info-table-title'>ราคาและสต็อกตาม Lot</h6>
                    <table className='pv-info-table'>
                      <thead>
                        <tr>
                          <th>หน่วย</th>
                          <th>ราคา</th>
                          <th>Exp.</th>
                          <th>คงเหลือ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableitem.map((item) => (
                          <tr key={item.pricelist_id}>
                            <td>{item.unit} ชิ้น</td>
                            <td>
                              {Number(item.pricepromotion) > 0 ? (
                                <>
                                  <strong className='text-danger'>
                                    {Number(item.pricepromotion).toLocaleString()} ฿
                                  </strong>
                                  <span className='pv-info-price-old ml-1'>
                                    {Number(item.price).toLocaleString()} ฿
                                  </span>
                                </>
                              ) : (
                                <strong>{Number(item.price).toLocaleString()} ฿</strong>
                              )}
                            </td>
                            <td>{fmtExpire(item.expire)}</td>
                            <td>{item.stock}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {detailTab === 'compare' && (
              <div role='tabpanel'>
                {product_compare.length > 0 ? (
                  <div className='pv-compare-grid'>
                    {product_compare.map((item) => (
                      <Link
                        key={item.shop_id}
                        to={`/marketplace/productview?shopitem=${item.shopitem_id}&productitem=${item.productitem_id}`}
                        className='pv-compare-card'
                      >
                        <div className='pv-compare-shop'>
                          <i className='fe-shopping-bag text-primary mr-2'></i> {item.shop_name}
                        </div>
                        <div className='text-muted small mb-2'>
                          <i className='fe-map-pin mr-1'></i> {item.shop_province}
                        </div>
                        <div className='d-flex justify-content-between align-items-end'>
                          <div className='small text-muted'>
                            Exp. {fmtExpire(item.first_expire)}
                          </div>
                          <div className='pv-compare-price'>
                            {Number(item.postprice).toLocaleString()} ฿
                          </div>
                        </div>
                        <div className='small text-muted mt-1 text-right'>
                          หน่วย {item.first_priceunit} ชิ้น
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className='pv-tab-empty'>
                    <i className='fe-layers'></i>
                    <p>ยังไม่พบร้านอื่นที่ขายสินค้านี้</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={showDialogCallback_General}
        callback_confirm={showDialogCallback_Confirm}
        options={modal_popup}
      />
    </main>
  );
}

export default MarketPlace;
